import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const HubspotIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={dimensions}
				height={dimensions}
				viewBox="0 0 13.107 13.099"
				preserveAspectRatio="xMidYMid"
			>
				<path
					d="M12.027 6.222a3.33 3.33 0 0 0-1.209-1.201c-.382-.222-.777-.363-1.223-.424V3a1.17 1.17 0 0 0 .722-1.097 1.2 1.2 0 0 0-1.2-1.206 1.21 1.21 0 0 0-1.21 1.206c0 .49.26.908.707 1.097v1.588a3.49 3.49 0 0 0-1.064.334L3.275 1.685c.03-.113.056-.23.056-.353 0-.738-.598-1.336-1.336-1.336S.66.594.66 1.332s.598 1.336 1.336 1.336c.252 0 .485-.074.686-.195l.28.212L6.797 5.45c-.203.186-.392.398-.543.636-.306.485-.493 1.018-.493 1.6v.12a3.35 3.35 0 0 0 .21 1.156c.116.316.286.604.497.864l-1.274 1.277c-.377-.14-.8-.047-1.085.238-.194.193-.303.456-.302.73s.108.535.303.73.456.303.73.303.537-.108.73-.303.303-.456.302-.73a1.03 1.03 0 0 0-.048-.31l1.316-1.316c.18.125.375.23.585.32a3.42 3.42 0 0 0 1.369.288h.09c.552 0 1.073-.13 1.562-.395a3.23 3.23 0 0 0 1.224-1.153c.307-.49.475-1.033.475-1.63v-.03c0-.587-.136-1.128-.42-1.624zM10.42 8.984c-.357.397-.768.642-1.232.642H9.1c-.265 0-.525-.073-.778-.207a1.8 1.8 0 0 1-.682-.621c-.184-.26-.284-.544-.284-.845v-.09c0-.296.057-.577.2-.842.153-.3.36-.515.635-.694s.558-.265.88-.265h.03c.29 0 .567.057.827.19a1.75 1.75 0 0 1 .65.591 1.88 1.88 0 0 1 .291.83l.007.187c0 .407-.156.784-.467 1.126z"
					fill="#f8761f"
				/>
			</svg>
		</StyledSpan>
	);
};

HubspotIcon.SIZE = SIZE;
HubspotIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
